import React from 'react';
import image2 from '../../images/404-error-game-style-vector-18273699.jpg'
import './NotFound.css'

const NotFound = () => {
    return (
        <div className='error'>
            <img src={image2} alt="" />
        </div>
    );
};

export default NotFound;